/*
 * i18n (psychology-web)
 */
import { initI18n } from "@psychology/intl"
import enUS from "./locales/en-US.json"
import frCA from "./locales/fr-CA.json"

initI18n({ "en-US": enUS, "fr-CA": frCA })
